<template>
  <span>
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            small
            color="primary"
            @click="openForm()"
          >
            <v-icon small>fa-pencil-alt</v-icon>
          </v-btn>
        </template>
        <span>Editar perfil</span>
      </v-tooltip>
    <v-dialog scrollable persistent v-model="dialogShow" small max-width="850px">
    <v-card>
      <v-card-title class="mb-0 pb-0">
        <span
          class="title grey--text text--darken-2"
        >Editar perfil</span>
        <v-spacer></v-spacer>
        <v-btn icon  small @click="closeForm(item)">
            <v-icon small>fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="mt-0 pt-0">
        <span class="error--text" v-show="!profileFormValid">{{ errorMessage }}</span>
        <v-form ref="profileForm" v-model="profileFormValid" lazy-validation class="mt-0 pt-0" v-if="viewForm">
            <v-row v-if="isTradimus && grupoEconomico == 1">
                <v-col class="col-xs-12 col-sm-6">
                <v-switch
                  class="smallSwitch mt-0"
                  v-model="formData.UsuarioTradimus"
                  label="Usuário Tradimus"
                  color="accent"
                  hide-details
                  @change="selectUsuarioTradimus"
                ></v-switch>
                </v-col>
            </v-row>
            <v-row wrap class="text-sm-left">
              <v-col class="col-xs-12 col-sm-3 text-sm-right">
               <span class="headline">Administração</span> 
              </v-col>
              <v-col class="col-xs-6 col-sm-3 col-md-3 text-sm-left pl-2">
              <v-switch
                  class="smallSwitch mt-0"
                  v-model="formData.Permissao.portal"
                  :label="gruposAcessoTitles['administrador']"
                  color="primary"
                  value="administrador"
                  hide-details
                ></v-switch>
                  <!-- @change="adminstratorSelect" -->
              </v-col>
              <v-col class="col-xs-6 col-sm-3 col-md-3  text-sm-left pl-2">
                <v-switch
                  class="smallSwitch mt-0"
                  v-model="formData.Permissao.portal"
                  :label="gruposAcessoTitles['gestor']"
                  color="primary"
                  value="gestor"
                  hide-details
                ></v-switch>
              </v-col>
            </v-row>


            <v-row
              wrap
              v-bind:key="ind"
              v-for="(item, ind) in permissaoBaseCadastro"
              class="text-sm-left"
              v-show="ind != 'portal'"
            >
              <v-col class="col-xs-12 col-sm-3 text-sm-right">
               <span class="headline">{{ modulosTitles[ind] }}</span> 
              </v-col>
              <v-col
                class="col-xs-6 col-sm-3 col-md-3  text-sm-left pl-2"
                v-bind:key="ind+'_'+GrupoAcesso"
                v-for="GrupoAcesso in item"
              >
                <v-switch
                  class="smallSwitch mt-0"
                  v-model="formData.Permissao[ind]"
                  :label="gruposAcessoTitles[GrupoAcesso]"
                  color="primary"
                  :value="GrupoAcesso"
                  :disabled="allDisabled"
                  hide-details
                ></v-switch>
              </v-col>
            </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" height="30px" small outlined @click="closeForm(item)">Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" height="30px" small depressed @click="doConfirm">Confirmar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </span>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: "profilesForm",
  components: {},
  //permissionsCategories: [],
  props: {
    editButton: Boolean,
    openForm: Function,
    closeForm: Function,
    dialog: Boolean,
    isNew: Boolean,
    item: String,
  },
  data: function () {
    return {
      allDisabled: false,
      errorMessage: '',
      profileFormValid: true,
      formData: {
        Permissao:{},
        UsuarioTradimus: false
        },
      validForm: true,
      viewForm: true,
      valor: ''
    };
  },
  computed: {
    ...mapState({
      isTradimus: state => state.userData.userData.UsuarioTradimus,
      modulosTitles: state => state.permissions.modulosTitles,
      gruposAcessoTitles: state => state.permissions.gruposAcessoTitles,
      grupoEconomico: state => state.permissions.grupoEconomico,
      permissaoBaseCadastro: state => state.permissions.permissaoBaseCadastro,
      permissaoInicial: state => state.permissions.permissaoInicial
    }),
    dialogShow() {
      return this.dialog
    },
  },
  watch: {
    dialog(val) {
        // this.viewForm = val
        this.allDisabled = false
        let permissaoInicial = this.$store.state.permissions.permissaoInicial
        this.formData.Permissao =  (val && this.item=="{}" && this.isNew)? Object.assign({}, permissaoInicial) : Object.assign({}, permissaoInicial, JSON.parse(this.item).Permissao)
        this.formData.UsuarioTradimus =  (this.isNew && this.item=="{}")? false : JSON.parse(this.item).UsuarioTradimus
        this.profileFormValid = true
        this.errorMessage = ''
        // if(this.formData.Permissao.portal && this.formData.Permissao.portal.indexOf("administrador") > -1){
        //   this.adminstratorSelect(this.formData.Permissao.portal)
        // }
    },
  },
  created() {    
    this.formData.Permissao = Object.assign({},this.$store.state.permissions.permissaoInicial)
    this.formData.UsuarioTradimus = false
  },
  methods: {
     adminstratorSelect(val) {
          if(val && val.indexOf("administrador") > -1 && !this.formData.UsuarioTradimus) {
            this.allDisabled = true
            let allModules = Object.keys(this.formData.Permissao)
            allModules.forEach(mod => (mod != 'portal')? this.formData.Permissao[mod] = [] : [] )
          } else {
            this.allDisabled = false
          }
      },
    selectUsuarioTradimus(val){
      if(val){
        // this.viewForm = false
        setTimeout(()=>{
          this.formData.Permissao = {...this.permissaoBaseCadastro}
          this.allDisabled = false
          this.$nextTick(() => this.viewForm = true )
        }, 200)
      } else {
        // this.viewForm = false
        setTimeout(()=>{
          this.formData.Permissao = Object.assign({},this.$store.state.permissions.permissaoInicial)
          this.allDisabled = false
          this.$nextTick(() => this.viewForm = true )
        }, 200)

      }
    },
    doConfirm() {
      let hasSelection = Object.values(this.formData.Permissao).find(mod => mod.length)
      if (hasSelection == undefined) {
        this.profileFormValid = false
        this.errorMessage = 'Selecione ao menos um perfil.'
        return
      }
      this.closeForm(this.formData)
    },
  },
};
</script>

<style>
.permissionTitle.red--text,
.permissionTitle.red--text::before {
  content: "*";
  color: #f44336 !important;
}
.category-line {
  border-bottom: solid 1px #ccc;
}
.category-line h3 {
  padding-top: 1em;
}
</style>
